module.exports = __webpack_public_path__ + "img/高通1.4c780628.png";